import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@ngneat/reactive-forms';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TableFormService<T> {
  private keyForm!: string;

  public get keyTable() {
    return this.keyForm;
  }

  public set keyTable(value: string) {
    this.keyForm = value;
    this.formGroups = {
      ...this.formGroups,
      [value]: new FormGroup({}),
    };
  }

  formGroups: {
    [key: string]: FormGroup<{
      [key: string]: FormGroup<{
        [key: string]: FormControl<any>;
      }>;
    }>;
  } = {};

  tableForm: FormGroup<{
    [key: string]: FormGroup<{
      [key: string]: FormControl<any>;
    }>;
  }> = new FormGroup({});

  tableData$$!: BehaviorSubject<T[]>;
  tableDataEditeCart$$!: BehaviorSubject<T[]>;

  removeControls() {
    Object.keys(this.formGroups[this.keyTable].controls).forEach((key) => {
      this.formGroups[this.keyTable].removeControl(key);
    });
  }
}
